import { getInfiltrationScore } from "../../../hsa/infiltration"
import { IHealthySoilsAssessment } from "../../../hsa/types"
import { defineComponent, IOmniaSession, IOmniaShell, IUibModalScope } from "../../../omnia"
import { ISoilService } from "../../../types"
import { AllocPopupBase } from "../alloc-base"

export class HsaAllocPopupCtrl extends AllocPopupBase<IHealthySoilsAssessment> {

    static create(): ng.IDirective {

        return defineComponent(HsaAllocPopupCtrl, "app/soil/dashboard/alloc/hsa/alloc-popup.html", {
            context: "="
        });

    };

    static $inject = ["$scope", "OmniaSoilService", "OmniaSession", "OmniaShell"];

    constructor($scope: ng.IScope, protected svc: ISoilService, private session: IOmniaSession, shell: IOmniaShell) {

        super($scope, shell, "healthy soils assessment");
        this.$scope = <IUibModalScope>$scope.$parent;
    }

    $onInit() {
        this.setupAllocations()
    }

    protected setupAllocations() {

        this.availableItems = this.svc.getHealthySoilsAssessments();
        this.selectedItems = this.availableItems
            .filter(s => s.Allocations.filter(a => a.FieldId === this.field.fieldId).length > 0);
        this.availableItems = this.availableItems
            .filter(a => this.selectedItems.indexOf(a) === -1);

        this.filter();

    }

    protected getDescription(assessment: IHealthySoilsAssessment): string {

        return assessment.SamplingDate.toLocaleDateString() +
            " - Infiltration rate : " +
            getInfiltrationScore(assessment.InfiltrationRate) +
            " - Vess score : " +
            assessment.VessScore;

    }

    commit(): void {

        this.svc.allocHsa(this.field.fieldId, this.selectedItems.map(a => a.HealthySoilsAssessmentId))
            .then(() => this.cancel());

    }

}
